document.addEventListener('optin-changed', (e) => {
  //console.log('xxx opted in for subscription:', e.detail)
  const optedIn = e.detail.optedIn
  const btn = document.querySelector('span[data-add-to-cart-text]')
  if (btn) {
    if (optedIn) {
      btn.textContent = 'SUBSCRIBE NOW'
    } else {
      btn.textContent = 'ADD TO CART'
    }
  }
})

document.addEventListener('DOMContentLoaded', updateCTA)
document.addEventListener('change', updateCTA)

function updateCTA() {
  //console.log('xxx updateCTA')
  const state = window.OG.store.getState()
  const btn = document.querySelector('span[data-add-to-cart-text]')
  if (state && btn) {
    //console.log('xxx state:', state)
    const optedInArray = state.optedin
    const variantId = document.querySelector('input[name="id"]').value
    if (variantId && optedInArray.length) {
      const match = optedInArray.find(obj => obj.id === variantId)
      if (match) {
        btn.textContent = 'SUBSCRIBE NOW'
      } else {
        btn.textContent = 'ADD TO CART'
      }
    }
  }
}